export default __webpack_public_path__ + "static/media/icon-sun.f28a8996.svg";